module.exports = __webpack_public_path__ + "files/d8ff5effbd42e45b79308e4697eb35a2.eot";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/google-fonts/fonts/Exo-2-regular.eot
// module id = 320
// module chunks = 60